import type { FC } from 'react';
import React from 'react';
import classNames from 'clsx';

import VectorImage from '../../../../VectorImage/viewer/VectorImage';
import {
  DIRECTION_LEFT_TO_RIGHT,
  DIRECTION_RIGHT_TO_LEFT,
  TEST_ID_BADGE,
  TEST_ID_ICONS,
} from '../../../constants';
import type { ILoginSocialBarProps } from '../../../LoginSocialBar.types';
import styles from './LoginSocialBarIcons.scss';

type ILoginSocialBarIconsProps = Pick<
  ILoginSocialBarProps,
  'iconItems' | 'direction'
> & {
  containerId: ILoginSocialBarProps['id'];
};

const getIconAriaLabel = (label: string, displayCount?: number) => {
  if (!label) {
    return;
  }
  return typeof displayCount === 'number' ? `${displayCount} ${label}` : label;
};

const getIconBadgeLabel = (count: number) =>
  count >= 1000 ? `${Math.floor(count / 1000)}k` : count;

export const LoginSocialBarIcons: FC<ILoginSocialBarIconsProps> = ({
  containerId,
  iconItems,
  direction,
}) => {
  // TODO - should this be moved into css var?
  const className = classNames(styles.root, {
    [styles.rtl]: direction === DIRECTION_RIGHT_TO_LEFT,
    [styles.ltr]: direction === DIRECTION_LEFT_TO_RIGHT,
  });

  return (
    <nav className={className} data-testid={TEST_ID_ICONS}>
      {iconItems.map(({ iconSvgContent, link, label, displayCount }, index) => (
        /**
         * TODO - reuse LogicSocialButton
         */
        <div
          key={index}
          className={classNames(styles.icon, {
            [styles.withCount]: typeof displayCount === 'number',
          })}
        >
          <VectorImage
            id={`${containerId}-icon`}
            svgContent={iconSvgContent}
            link={link}
            ariaLabel={getIconAriaLabel(label, displayCount)}
            shouldScaleStroke={false}
            withShadow={false}
          />
          {typeof displayCount === 'number' && (
            <span className={styles.badge} data-testid={TEST_ID_BADGE}>
              {getIconBadgeLabel(displayCount)}
            </span>
          )}
        </div>
      ))}
    </nav>
  );
};
